'use client';

import { c as _c } from "react/compiler-runtime";
import { useCallback } from 'react';
import { Button, DeclarativeForm, FlexContainer, Label } from '@bridge/ui';
import { getMagicLinkFormConfig } from '../_formConfigs/loginFormConfigs';
import type { ReactElement } from 'react';
import type { LoginEmailFormValues } from '../_schemas/loginFormSchemas';
interface MagicLinkFormProps {
  isGeneratingLink: boolean;
  onSubmit: (values: LoginEmailFormValues) => Promise<void>;
  onValidationError?: () => void;
}
const MagicLinkForm = t0 => {
  const $ = _c(10);
  const {
    isGeneratingLink,
    onSubmit,
    onValidationError
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = getMagicLinkFormConfig();
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const formConfig = t1;
  let t2;
  if ($[1] !== onValidationError) {
    t2 = () => {
      onValidationError?.();
    };
    $[1] = onValidationError;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const handleError = t2;
  let t3;
  if ($[3] !== isGeneratingLink) {
    t3 = () => <Button className="h-12 w-full" pending={isGeneratingLink} size="lg" type="submit" variant="primary">Continue</Button>;
    $[3] = isGeneratingLink;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const actionsComponent = t3;
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <Label className="text-content-secondary" size="sm">Request a magic link to be sent to your email</Label>;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== actionsComponent || $[7] !== handleError || $[8] !== onSubmit) {
    t5 = <FlexContainer className="flex flex-col gap-2" items="center">{t4}<DeclarativeForm actionsComponent={actionsComponent} config={formConfig} onError={handleError} onSubmit={onSubmit} showSeparator={false} /></FlexContainer>;
    $[6] = actionsComponent;
    $[7] = handleError;
    $[8] = onSubmit;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  return t5;
};
export default MagicLinkForm;